import { lighten, transparentize } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';

import { FlexRowCenterVertical } from '@main/core-ui';
import { responsive, sp } from '@main/theme';

/**
 * Override ant component styling to match themes
 */
export const ClassOverrides = createGlobalStyle`
  .ant-slider.ant-slider-with-marks {
    margin-bottom: 10px;
  }

  .ant-slider-with-marks {
    margin-bottom: 10px;
  }

  .ant-slider-rail {
    background-color: ${({ theme }) =>
      transparentize(0.7, theme.colors.secondary)}!important;
  }

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.colors.primary}!important;
  }

  .ant-slider-track {
    background-color: ${({ theme }) =>
      lighten(0.45, theme.colors.secondary)}!important;
  }

  .ant-slider-handle {
    border-color: ${({ theme }) => theme.colors.secondary}!important;
  }

  .ant-slider-handle:focus {
    border-color: ${({ theme }) => theme.colors.secondary}!important;
    box-shadow: 0 0 0 5px ${({ theme }) =>
      transparentize(0.6, theme.colors.secondary)}!important;
  }

  .ant-slider-dot-active {
    border-color: ${({ theme }) =>
      lighten(0.5, theme.colors.secondary)}!important;
  }
`;

/**
 * The view past versions button wrapper
 */
export const ViewPastVersionsWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;

  :hover {
    opacity: 0.75;
  }

  ${responsive.beforeTablet} {
    margin-left: ${sp(0.7)};
  }
`;

/**
 * The view past versions styled icon
 */
export const ViewPastVersionsIconWrapper = styled(FlexRowCenterVertical)`
  color: ${({ theme }) => theme.colors.secondary};

  ${responsive.justTablet} {
    margin-top: 2px;
  }

  ${responsive.beforeDesktop} {
    font-size: 14px;
  }
`;

/**
 * The view past versions message label
 */
export const ViewPastVersionsLabel = styled.p`
  margin: 0 0 0 ${sp(0.7)};
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 600;

  ${responsive.beforeTablet} {
    display: none;
  }

  ${responsive.beforeDesktop} {
    font-size: ${sp(1.75)};
  }
`;

/**
 * The button to close the policy versions footer
 */
export const CloseButtonWrapper = styled(FlexRowCenterVertical)`
  cursor: pointer;
  flex-grow: 0;
  transition: opacity 0.3s;
  opacity: 1;

  &:hover {
    opacity: 0.6;
  }
`;

/**
 * The policy slider wrapper
 */
export const SliderWrapper = styled.div`
  flex-grow: 0.4;
  width: 40%;
`;

/**
 * The changes switch wrapper
 */
export const ChangesSwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
  margin-bottom: 5px;
`;

/**
 * The switch label to toggle changes view
 */
export const SwitchLabel = styled.div`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  margin-bottom: 9px;
`;

/**
 * The PolicyVersions footer wrapper
 */
export const FooterWrapper = styled.div`
  width: 100%;
  padding: ${sp(3)} ${sp(5)};
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;
